const STORAGE_KEY = 'evplanner.dismissed_alerts';

export function readDismissedAlertIds() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? new Set(JSON.parse(raw)) : new Set();
  } catch (_err) {
    return new Set();
  }
}

export function dismissAlertId(id) {
  const ids = readDismissedAlertIds();
  ids.add(id);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
  } catch (_err) {
    // localStorage indisponível (modo privado, quota) — dispensa fica só em memória.
  }
}
